import React from "react";
import styled from "styled-components";
import {asLocalDateTime} from "../../../../util/timeDescription";
import {logAction} from "../../../../logging/logEvent";
import {subduedTextColour} from "../../../../style/styleConsts";
import {TruncatedName} from "./TruncatedName";
import {Tooltip} from "antd";

const MessageNotification = styled(TruncatedName)`
    font-size: 9px;
    color: ${subduedTextColour};
    text-decoration: underline;
    text-decoration-style: dashed;
`;

const logMouseOverMessage = (portfolioName, portfolioCompanyName) => {
    logAction({
        type: "AllClientsMouseOverPortfolioMessage",
        portfolioName,
        portfolioCompanyName
    });
};

const PortfolioTooltipMessage = ({portfolioMessage}) => {
    if (!portfolioMessage) {
        return null;
    }
    return <div>
        <i>{portfolioMessage.author} says:</i>
        <div>{portfolioMessage.message}</div>
    </div>;
};

export const PortfolioMessage = ({portfolioName, portfolioCompanyName, portfolioMessage}) => {
    if (!portfolioMessage) {
        return null;
    }
    const message = <PortfolioTooltipMessage portfolioMessage={portfolioMessage}/>;
    return <MessageNotification>
        <Tooltip title={message}
                 mouseEnterDelay={0}
                 mouseLeaveDelay={0.1}
                 placement="bottom"
                 overlayClassName="t-formatted-tooltip"
                 onMouseEnter={() => logMouseOverMessage(portfolioName, portfolioCompanyName)}>
            <span>Message posted {asLocalDateTime(portfolioMessage.publishedAt)}</span>
        </Tooltip>
    </MessageNotification>;
};